import { createContext, useContext, useState, useCallback, useEffect } from "react";

// Lets the currently-mounted (mobile) Go Deeper chat register how to open itself,
// so the footer's prominent centre "Go Deeper" tab can trigger it from the tab bar.
// requestOpen() opens it now if the chat is already mounted, otherwise it queues a
// pending-open that fires the moment the chat registers (handles landing-page races).
const DeeperNavContext = createContext(null);

export function DeeperNavProvider({ children }) {
  const [opener, setOpenerState] = useState(null);
  const [pending, setPending] = useState(false);

  const setOpener = useCallback((fn) => setOpenerState(() => fn || null), []);
  const requestOpen = useCallback(() => {
    if (opener) opener();
    else setPending(true);
  }, [opener]);

  useEffect(() => {
    if (opener && pending) {
      opener();
      setPending(false);
    }
  }, [opener, pending]);

  return (
    <DeeperNavContext.Provider value={{ opener, setOpener, requestOpen }}>
      {children}
    </DeeperNavContext.Provider>
  );
}

export function useDeeperNav() {
  return useContext(DeeperNavContext) || { opener: null, setOpener: () => {}, requestOpen: () => {} };
}
